import '../css/MenuLateral.css'
import React, {useEffect, useState} from 'react'




//Pour gérer l'ajout et la suppression de sous catégories dans la liste selectedCategories
const toggleSousCategory = (setSelectedSousCategories, subcategory) => {
    setSelectedSousCategories((prev) => {
        const isSelected = prev.includes(subcategory);
        if (isSelected) {
            return prev.filter((sub) => sub !== subcategory);
        } else {
            return [...prev, subcategory];
        }
    });
};


// Pour gérer l'ajout et la suppression de categories dans la liste selectedCategories
const toggleCategories = (dicoCategories, setSelectedProfessions, setSelectedCategories, setSelectedSousCategories, categorie) => {
    setSelectedProfessions([])
    setSelectedCategories((prev) => {
        const isSelected = prev.includes(categorie);
        if (isSelected) {
            const updatedCategories = prev.filter((cat) => cat !== categorie);
            setSelectedSousCategories((subPrev) =>
                subPrev.filter(
                    (sub) => !dicoCategories[categorie]?.includes(sub) 
                )
            );
            return updatedCategories;
        } else {
            setSelectedSousCategories((subPrev) => [
                ...subPrev,
                ...dicoCategories[categorie]?.filter((sub) => !subPrev.includes(sub)), 
            ]);
            return [...prev, categorie];
        }
    });
};

const toggleProfession=(prof, setSelectedCategories, setSelectedSousCategories, setSelectedProfessions)=>{
    setSelectedCategories([])
    
    setSelectedSousCategories([])
    setSelectedProfessions((prev) => {
        const isSelected = prev.includes(prof);
        if (isSelected) {
            const updatedProfessions = prev.filter((pro) => pro !== prof);
            
            return updatedProfessions;
        } else {
            
            return [...prev, prof];
        }
    });
    

  
}



const MenuLateral = ({
  showMenuLateral,
  isPhone,
  telechargement_PDF,
  rayonDeRecherche,
  setRayonDeRecherche,
  address,
  setAddress,
  handleKeyDown,
  geocodeResults,
  handleSelectResult,
  handleUserCurrentLocation,
  sousCategories,
  selectedSousCategories,
  setSelectedSousCategories, 
  setSelectedProfessions, 
  setSelectedCategories,
  dicoCategories,
  selectedCategories,
  professions,
  selectedProfessions,
  setUseFitBounds, 
  setCoordonnéesPointCentral,
}) => {

    // Fonction qui navigue vers la page "Ajout Établissement"
    const handleNavigation = () => {
        const url = `${window.location.origin}/ajout_etablissement`; 
        window.open(url, "_blank"); 
    };

    //Cette variable pour savoir si on est sur le paneau des professionnels ou bien des établissements de santé
    const [isSecondPanelVisible, setIsSecondPanelVisible] = useState(false); 

    //Ces deux variables pour basculer du menu professionnels à etablissements et vice-versa
    const showSecondPanel = () => setIsSecondPanelVisible(true); 
    const showFirstPanel = () => setIsSecondPanelVisible(false);




    
    



    





    //POUR LE BOUTON "LIEU"
    const [isLieuOpen, setIsLieuOpen] = useState(false) //Variable pour indiquer si le menu "Lieu" est ouvert ou non, que ce soit dans le panneau des établissements ou des professionnels

    //Cette fonction est appelé lorsque l'utilisateur clique sur le bouton "Lieu". A ce moment là, on ferme les autres menus (barres de recherches et menus déroulants)
    const toggleDropdown = () => {
        setShowMoteurDeRechercheSousCategories(false);
        setShowMoteurDeRechercheProfessions(false);
        setShowCategoriesMenu(false);
        setShowProfessionsMenu(false);
        setAfficherMenuTelechargement(false)
        setIsLieuOpen((prev) => !prev);
        };
    






    //POUR LES BARRES DE RECHERCHE DES ETABLISSEMENTS ET PROFESSIONNELS    
    const [showMoteurDeRechercheSousCategories, setShowMoteurDeRechercheSousCategories]=useState(false) // Indique si on affiche la barre de recherche des établissements de santé
    const [showMoteurDeRechercheProfessions, setShowMoteurDeRechercheProfessions]=useState(false) // Indique si on affiche la barre de recherche des professions

    const [filteredSousCategories, setFilteredSousCategories] = useState(sousCategories); // Les catégories que l'on affiche lorsque l'utilisateur commence à taper dans la barre de recherche des établissements
    const [filteredCategories, setFilteredCategories] = useState(Object.keys(dicoCategories)); // Les catégories que l'on affiche lorsque l'utilisateur commence à taper dans la barre de recherche des établissements
    const [filteredProfessions, setFilteredProfessions] = useState(professions); // Les professions que l'on affiche lorsque l'utilisateur commence à taper dans la barre de recherche des professions
    const [searchQuery, setSearchQuery] = useState(''); // Ce que l'utilisateur tape dans la barre de recherche. Mis à jour continuellement

    // Ces deux useEffect sont déclenchés lorsque searchQuery est modifié. Ils permettent de filtrer les établissements et professions continuellement durant la recherche
    useEffect(() => {
        const filtered = professions.filter(profession =>
            profession.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredProfessions(filtered);
    }, [searchQuery, professions]);

    useEffect(() => {
        const filtered = sousCategories.filter(category =>
            category.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredSousCategories(filtered);
    }, [searchQuery, sousCategories]);

    useEffect(() => {
        const filtered = Object.keys(dicoCategories).filter(category =>
            category.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredCategories(filtered);
    }, [searchQuery, dicoCategories]);


    //Ces deux fonctions sont déclenchés quand l'utilisateur clique sur les menus "Rechercher un établissement" ou "Réchercher une profession" dans le menu latéral
    const afficherMoteurCategories = () => {
        setShowMoteurDeRechercheSousCategories((prev) => !prev);
        setIsLieuOpen(false);
        setShowCategoriesMenu(false);
        setAfficherMenuTelechargement(false)
        setSearchQuery('');
    };

    const afficherMoteurProfessions = () => {
        setShowMoteurDeRechercheProfessions((prev) => !prev);
        setIsLieuOpen(false);
        setShowProfessionsMenu(false);
        setAfficherMenuTelechargement(false)
        setSearchQuery('');
    };


    //Ces deux fonctions sont déclenchés lorsque l'utilisateur clique sur une catégorie (une profession) dans la barre de recherche 
    const toggleSousCategoriesMoteurdeRecherche = (category) => {
        setSelectedProfessions([])
        setSelectedSousCategories(prevState =>
            prevState.includes(category)
                ? prevState.filter(item => item !== category) 
                : [...prevState, category] 
        );
    };




    const toggleProfessionMoteurdeRecherche = (profession) => {
        setSelectedSousCategories([])
        setSelectedProfessions(prevState =>
            prevState.includes(profession)
                ? prevState.filter(item => item !== profession) 
                : [...prevState, profession] 
        );
    };




    







    //POUR LES MENUS DEROULANTS "CATEGORIES" ET "LISTE DES PROFESSIONS"
    const [showProfessionsMenu, setShowProfessionsMenu] = useState(false) // Variable pour indiquer si le menu déroulant des professions est affiché ou non
    const [showCategoriesMenu, setShowCategoriesMenu] = useState(false); // Variable pour indiquer si le menu déroulant des catégories est affiché ou non

    //Ces deux fonctions sont déclenchés lorsque l'utilisateur clique sur le menu catégorie (ou profession) dans le menu déroulant

    const afficherCategories = ()=>{
        setShowCategoriesMenu((prev)=>!prev);
        setIsLieuOpen(false);
        setShowMoteurDeRechercheSousCategories(false);
        setAfficherMenuTelechargement(false);
        setSearchQuery('');
    }






    //POUR LE BOUTON DE TELECHARGEMENT
    const [afficherMenuTelechargement, setAfficherMenuTelechargement] = useState(false)
    const afficherDownload=()=>{
        setAfficherMenuTelechargement(!afficherMenuTelechargement)
        setShowMoteurDeRechercheSousCategories(false);
        setShowMoteurDeRechercheProfessions(false);
        setShowCategoriesMenu(false);
        setShowProfessionsMenu(false);
    }








    


    


  return (
    <div className={`menu-lateral ${showMenuLateral ? 'visible' : ''}`}>
                {showMenuLateral && (
                    
                    <div>
                        <div className="logo-container">
                            <img src="ToobibLogoRemix.png" alt="Logo" className='logo-toobib'></img>
                        </div>
                        
                        

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center', 
                                marginTop: window.innerWidth <= 500 ? '-5%' : !isPhone ? '-2%' : '-4%',
                                position: 'relative',
                                width:"100%"
                            }}
                        >
                            <button 
                                className="tab-button left-tab" 
                                onClick={showFirstPanel}
                                style={{backgroundColor:!isSecondPanelVisible ? 'rgb(27, 13, 71)' : '#737199', maxWidth:!isSecondPanelVisible ? '60%':'40%'}}
                            >
                                <span className="titres-menu-lateral" style={{fontSize:!isSecondPanelVisible ? '18px' : '14px'}}>
                                    {window.innerWidth <= 1000 ? 'Etablissements' : 'Etablissements de santé'}
                                </span>
                            </button>
                            <button 
                                className="tab-button right-tab" 
                                onClick={showSecondPanel}
                                style={{backgroundColor:isSecondPanelVisible ? 'rgb(27, 13, 71)' : '#737199', maxWidth:!isSecondPanelVisible ? '40%':'60%'}}
                            >
                                <span className="titres-menu-lateral" style={{fontSize:!isSecondPanelVisible ? '14px' : '18px'}}>
                                    {window.innerWidth <= 1000 ? 'Professionnels' : 'Professionnels de santé'}
                                </span>
                            </button>
                        </div>


                            
                        
                        
                        
                        <div style={{
                            overflow: "hidden",
                            backgroundColor: 'rgb(27, 13, 71)',
                            borderBottomRightRadius: '10px',
                            borderBottomLeftRadius: '10px',
                            flexGrow: 1, 
                            padding: '10px'
                        }}>



                        {!isSecondPanelVisible && (
                        <div>
                        <div style={{marginTop:"5%"}}>
                            <button className="bouton-lieu" onClick={() => toggleDropdown()}>
                                <span>Zone de recherche</span>
                            </button>
                        </div>
                        
                        {isLieuOpen && (
                            <div>
                        
                        
                        <div className="Curseur-rayon-de-recherche">
                        
                            <label>Rayon de recherche :</label>
                            <div className="range-container">
                                <span className="range-min">{rayonDeRecherche < 1000 ? "0 km" : "1 km"}</span>
                                <input
                                    type="range"
                                    min={rayonDeRecherche < 1000 ? 0 : (rayonDeRecherche === 1000 ? 0 : 1)}
                                    max={rayonDeRecherche < 1000 ? 1 : 50}
                                    step={rayonDeRecherche <= 1000 ? 0.1 : 1}
                                    value={rayonDeRecherche / 1000}
                                    onChange={(e) => setRayonDeRecherche(parseFloat(e.target.value) * 1000)}
                                />
                                <span className="range-max">{rayonDeRecherche < 1000 ? "1 km" : "50 km"}</span>
                            </div>
                            <div className="range-value">
                                {rayonDeRecherche < 1000 
                                    ? `${rayonDeRecherche} m` 
                                    : `${(rayonDeRecherche / 1000).toFixed(1)} km`}
                            </div>
                            
                        </div>
                        
                        <div>
                        <div className="barre-de-recherche-adresse">
                        <input
                            type="text"
                            placeholder="Rechercher une adresse"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        
                        <button onClick={()=>handleUserCurrentLocation(setUseFitBounds, setCoordonnéesPointCentral)} title="Aller à ma Position">
                            <img src="gps_blanc.png" alt="Icone de géolocalisation"></img>
                        </button>
                        {geocodeResults.length > 0 && (
                        <div className="results-list">
                            <ul>
                            {geocodeResults.map((result, index) => (

                                <li key={index} onClick={() => handleSelectResult(result)} className="result-item">
                                <img 
                                src="Marqueur_Menu_Adresses.png" 
                                alt="Icone de proposition" 
                                className="result-icon" 
                            />
                                <span className="result-label" >{result.label}</span>
                                
                                </li>
                            ))}
                            </ul>
                        </div>
                        )}
                        </div>
                        
                        </div>

                        
                        

                        </div>
                        )}
                        <div>
                            <button className="bouton-lieu" onClick={() => afficherMoteurCategories()}>
                                <span>Recherche par type d'établissement</span>
                            </button>
                        </div>
                        {showMoteurDeRechercheSousCategories && (
                            <div style={{ padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Recherche un type d'établissement"
                                style={{ width: '100%', marginBottom: '10px', padding: '8px', borderRadius:5 }}
                            />
                             
                            <div className="liste-des-categories" style={{ maxHeight: '120px', overflowY: 'auto', padding: '10px', width: '100%', paddingRight: '10px' }}>
                                {filteredSousCategories.map((category) => (
                                    <label key={category} style={{ display: 'block', marginBottom: '10px', color: 'white' }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedSousCategories.includes(category)}
                                            onChange={() => toggleSousCategoriesMoteurdeRecherche(category)}
                                        />
                                        {category}
                                    </label>
                                ))}
                            </div>
                        </div>
                        
                        )}
                        <button className="bouton-lieu" onClick={() => afficherCategories()}>
                            Recherche par catégorie
                        </button>
                        {showCategoriesMenu && (
                            <div style={{ padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>

                                <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Rechercher une catégorie d'établissement"
                                style={{ width: '100%', marginBottom: '10px', padding: '8px', borderRadius:5 }}
                            />
                                
                                <div className="liste-des-categories" style={{ maxHeight: '120px', overflowY: 'auto', padding: '10px', width: '100%', paddingRight: '10px' }}>
                                    
                                {filteredCategories.map((categorie) => (
                                    <div key={categorie} style={{ marginBottom: '20px' }}>
                                        <label style={{ display: 'block', marginBottom: '10px', color: 'white' }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedCategories.includes(categorie)}
                                                onChange={() => toggleCategories(dicoCategories, setSelectedProfessions, setSelectedCategories, setSelectedSousCategories, categorie)}
                                            />
                                            {categorie}
                                        </label>

                                        
                                        {selectedCategories.includes(categorie) && (
                                            <div style={{ marginLeft: '40px', color: 'lightgray' }}>
                                                {dicoCategories[categorie]?.map((subcategory) => (
                                                    <label key={subcategory} style={{ display: 'block', marginBottom: '5px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedSousCategories.includes(subcategory)}
                                                            onChange={() => toggleSousCategory(setSelectedSousCategories, subcategory)}
                                                        />
                                                        {subcategory}
                                                    </label>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                            </div>
                            
                        )}
                        <button className="bouton-lieu" onClick={() => afficherDownload()}>
                            Résumé de la recherche
                        </button>
                        {afficherMenuTelechargement && (
                            <div className="telechargement">
                                <span>Télécharger un résumé de votre recherche</span>
                            <button onClick={telechargement_PDF}>
                                <img style={{width: "auto", height: "auto",maxWidth: '50%',maxHeight: '50%'}} src="bouton_telecharger.png" alt="Right Arrow" />
                            </button>
                            </div>
                        )}
                        {!isPhone && (
                            <div className="div_bouton-ajout-etablissement">
                                
                            <button className="bouton-ajout-etablissement" onClick={handleNavigation}>
                                <span style={{fontSize:14}}>
                                    Un établissement que vous connaissez n'apparaît pas ? Ajoutez-le !
                                </span> 
                            </button> 
                            
                            </div>  
                            )} 
                        </div>)}


                        {/* 2ème panneau, celui des professionnels de sante*/}
                        {isSecondPanelVisible && (
                        <div style={{
                            
                            
                        }}>
                            <div style={{marginTop:"5%"}}>
                            <button className="bouton-lieu" onClick={() => toggleDropdown()}>
                                <span>Zone de recherche</span>
                            </button>
                        </div>
                        
                        {isLieuOpen && (
                            <div>
                        
                        
                        <div className="Curseur-rayon-de-recherche">
                        
                            <label>Rayon de recherche :</label>
                            <div className="range-container">
                                <span className="range-min">{rayonDeRecherche < 1000 ? "0 km" : "1 km"}</span>
                                <input
                                    type="range"
                                    min={rayonDeRecherche < 1000 ? 0 : (rayonDeRecherche === 1000 ? 0 : 1)}
                                    max={rayonDeRecherche < 1000 ? 1 : 50}
                                    step={rayonDeRecherche <= 1000 ? 0.1 : 1}
                                    value={rayonDeRecherche / 1000}
                                    onChange={(e) => setRayonDeRecherche(parseFloat(e.target.value) * 1000)}
                                />
                                <span className="range-max">{rayonDeRecherche < 1000 ? "1 km" : "50 km"}</span>
                            </div>
                            <div className="range-value">
                                {rayonDeRecherche < 1000 
                                    ? `${rayonDeRecherche} m` 
                                    : `${(rayonDeRecherche / 1000).toFixed(1)} km`}
                            </div>
                            
                        </div>
                        
                        <div>
                        <div className="barre-de-recherche-adresse">
                        <input
                            type="text"
                            placeholder="Rechercher une adresse"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        
                        <button onClick={()=>handleUserCurrentLocation(setUseFitBounds, setCoordonnéesPointCentral)} title="Aller à ma Position">
                            <img src="gps_blanc.png" alt="Icone de géolocalisation"></img>
                        </button>
                        {geocodeResults.length > 0 && (
                        <div className="results-list">
                            <ul>
                            {geocodeResults.map((result, index) => (

                                <li key={index} onClick={() => handleSelectResult(result)} className="result-item">
                                <img 
                                src="Marqueur_Menu_Adresses.png" 
                                alt="Icone de proposition" 
                                className="result-icon" 
                            />
                                <span className="result-label" >{result.label}</span>
                                
                                </li>
                            ))}
                            </ul>
                        </div>
                        )}
                        </div>
                        
                        </div>

                        
                        

                        </div>
                        
                        )}
                        <div>
                            <button className="bouton-lieu" onClick={() => afficherMoteurProfessions()}>
                                <span>Recherche par profession</span>
                            </button>
                        </div>
                        {showMoteurDeRechercheProfessions && (
                            <div style={{ padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Rechercher une profession"
                                style={{ width: '100%', marginBottom: '10px', padding: '8px', borderRadius:5 }}
                            />
                             
                                <div className="liste-des-categories" style={{ maxHeight: '150px', overflowY: 'auto', padding: '10px' , width:'100%'}}>
                                {filteredProfessions.map((profession) => (
                                    <label key={profession} style={{ display: 'block', marginBottom: '10px', color: 'white' }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedProfessions.includes(profession)}
                                            onChange={() => toggleProfessionMoteurdeRecherche(profession)}
                                        />
                                        {profession}
                                    </label>
                                ))}
                            </div>
                            
                        </div>
                        )}
                            
                            <button className="bouton-lieu" onClick={() => afficherDownload()}>
                                Résumé de la recherche
                            </button>
                            {afficherMenuTelechargement && (
                                <div className="telechargement">
                                    <span>Télécharger un résumé de votre recherche</span>
                                <button onClick={telechargement_PDF}>
                                    <img style={{width: "auto", height: "auto",maxWidth: '50%',maxHeight: '50%'}} src="bouton_telecharger.png" alt="Right Arrow" />
                                </button>
                                </div>
                            )}
                            </div>

                            )}
                        

                        </div>
                    
                        
                        
                    </div>
                    
                )}
            </div>
  );
};



export default MenuLateral;
